<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <h1 class="text-center">Expanding Your Business with Us</h1>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-center" cols="12" xs="12" sm="4">
                    <v-img src="https://assets.invisee.com/statis/revamp/main-ekspanding-business.png" max-height="264px" max-width="268px" class="mx-auto"></v-img>
                </v-col>
                <v-col class="text-left" cols="12" xs="12" sm="8">
                    <v-list>
                        <v-list-item-group>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-img src="https://assets.invisee.com/statis/revamp/icon-check.png" max-height="16px" max-width="16px" class="mx-auto"></v-img>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Kemudahan Integrasi

                                    </v-list-item-title>
                                    <div>
                                        Kemudahan berintegrasi dalam menghadirkan produk-produk investasi dengan sistem keuangan digital yang terbaik, aman dan terpercaya.
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-img src="https://assets.invisee.com/statis/revamp/icon-check.png" max-height="16px" max-width="16px" class="mx-auto"></v-img>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Keamanan Data
                                    </v-list-item-title>
                                    <div>
                                        Seluruh data yang terhubung, tersimpan dalam cloud private server yang ter-enkripsi.
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-img src="https://assets.invisee.com/statis/revamp/icon-check.png" max-height="16px" max-width="16px" class="mx-auto"></v-img>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Profesional
                                    </v-list-item-title>
                                    <div>
                                        Semua fitur dan sistem FUNDtastic+ diciptakan dan dikembangkan oleh tim ahli yang telah berpengalaman di bidang finansial dan teknologi.
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
    }
</script>

<style scoped>
    .v-application--is-ltr .v-list-item__icon{
        margin-right: 10px;
    }
    .v-list-item__title{
        color: #00a070;
        font-weight: bold;
        margin-bottom: 7px;
    }
</style>